import React from 'react';

import styles from './LoadingState.module.scss';

const LoadingState = () => {
  const generateUniqueKey = () => `${Date.now()}-${Math.random()}`;

  return (
    <div className={styles.loadState}>
      <div className={styles.loadingCards}>
        {Array.from({ length: 15 }).map(() => (
          <div key={generateUniqueKey()} className={styles.loadingCard}>
            <div className={styles.upperSection} />
            <div className={styles.lowerSectionSection} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingState;
